import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'

interface Props {
  children: React.ReactNode
}

export const TasksContainer = ({ children }: Props) => {
  const { breakpoint, isMobile } = useBreakpoint()
  const showCarousel = breakpoint === 'xl' || breakpoint === 'l'

  return (
    <Box
      gap="s16"
      overflowX="auto"
      flexWrap="noWrap"
      style={
        isMobile || showCarousel
          ? {
              flexDirection: showCarousel ? 'row' : 'column',
            }
          : {
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
            }
      }
    >
      {children}
    </Box>
  )
}
